import { UserManager } from "oidc-client-ts";
import type { RuntimeConfig } from "../../app/config";
import type { AuthPort } from "./auth-port";
import { LocalAuth } from "./local-auth";
import { OidcAuth, oidcSettings } from "./oidc-auth";

/** OIDC when /config.json names an identity provider; the local developer otherwise (development only). */
export function createAuth(config: RuntimeConfig, origin = window.location.origin): AuthPort {
  if (!config.oidc) return new LocalAuth();
  return new OidcAuth(new UserManager(oidcSettings(config.oidc, origin)));
}
